import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { Affix, Breadcrumb, Col, Grid, Layout, PageHeader, Row } from 'antd';
import classNames from 'classnames';

import { getBreadcrumb } from 'src/utils/breadcrumb';
import { toCamelCase } from 'src/utils/ConvertSlug';

import Footers from '../footer';
import HeaderNavigator from '../header/index';

import classes from './index.module.less';

type PageProps = {
	ctx: any;
	pageProps: object;
};

const MainLayout = (props: any) => {
	const { xs } = Grid.useBreakpoint();
	const router = useRouter();
	const { pageHeaderContent, isWhiteBackground } = props;
	const bodyWhite = pageHeaderContent?.title
		? classes['white-layout-body-card']
		: classes['white-layout-body'];
	const [scrollPosition, setScrollPosition] = useState(0);
	useEffect(() => {
		const handleScroll = () => {
			setScrollPosition(window.scrollY);
		};
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);
	const truncateString = (str: string) => {
		if (str?.length > 23) {
			return `${str.substring(0, 23)}...`;
		}
		return str;
	};
	const itemRender = () => {
		let bc = getBreadcrumb(router);
		const test = bc[1].path.split('?')[0];
		const cleaning = test.replace(/[\/-]/g, ' ');
		const words = cleaning.split(' ');
		const camelCaseString = words
			.map((word: any, index: any) => {
				if (index === 0) {
					return word.toLowerCase();
				}
				return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
			})
			.join(' ');

		const newBc =
			router.pathname === '/event/[sub]'
				? props?.bc
				:
				router.pathname === '/author/[sub]'
					? props?.bc
					: bc;
		const formatedBc: any = [];
		if (router.pathname === '/kehamilan/[sub]' || router.pathname === '/pasca-kehamilan/[sub]' || router.pathname === '/pra-kehamilan/[sub]') {
			pageHeaderContent?.breadcrumbs?.map((item: any) => {
				if (item.label && item.navigatePath) {
					let newdata = {
						path: item.navigatePath,
						breadcrumbName: item.label,
					};
					return formatedBc.push(newdata);
				}
			});
		} else {
			for (let i = 0; i < newBc.length; i++) {
				const bcItem = newBc[i];
				let newBcItem =
					i == 0
						? bcItem
						: {
							...bcItem,
							path: formatedBc[i - 1].path + bcItem.path,
							breadcrumbNoQuery: camelCaseString,
						};

				formatedBc.push(newBcItem);
			}
		}
		return formatedBc.map((r: any, i: number) => {
			if (formatedBc[0].path === '/event') {
				if (formatedBc.length === i + 1) {
					if (i === 1) {
						const bcName = xs ? truncateString(r.breadcrumbName) : r.breadcrumbName;
						const formattedBreadcrumbName = bcName
							.split('-')
							.map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
							.join(' ');
						return (
							<span key={r.path} className={classes.lastBreadcrumb}>
								{formattedBreadcrumbName}
							</span>
						);
					}
					return <span key={r.path}>{r.breadcrumbName}</span>;
				}
				if (i === 0) {
					return (
						<Breadcrumb.Item key={0}>
							<a href={`${process.env.NEXT_PUBLIC_WEB_URL}/event`}>
								<span className={classes.nameBreadcrumb} style={{ cursor: 'pointer' }}>
									{r.breadcrumbName}
								</span>
							</a>
						</Breadcrumb.Item>
					);
				} else {
					return (
						<Breadcrumb.Item key={r.path}>
							<a href={`${process.env.NEXT_PUBLIC_WEB_URL}${r.path}`}>
								<span className={classes.nameBreadcrumb} style={{ cursor: 'pointer' }}>
									{r.breadcrumbName}
								</span>
							</a>
						</Breadcrumb.Item>
					);
				}
			} else if (formatedBc[0].path === '/') {
				if (formatedBc.length === i + 1) {
					if (i === 1) {
						const bcName = xs ? truncateString(r.breadcrumbName) : r.breadcrumbName;
						const formattedBreadcrumbName = bcName
							.split('-')
							.map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
							.join(' ');
						return (
							<span key={r.path} className={classes.lastBreadcrumb}>
								{formattedBreadcrumbName}
							</span>
						);
					}
					return <span key={r.path} style={{ fontSize: `${xs ? '11px' : '16px'}` }}>{props.pageHeaderContent.breadcrumbs[2].label ? props.pageHeaderContent.breadcrumbs[2].label : r.breadcrumbName}</span>;
				}
				if (i === 0) {
					return (
						<Breadcrumb.Item key={0}>
							{
								r.breadcrumbName === 'Artikel' ?
									<a href={`${process.env.NEXT_PUBLIC_WEB_URL}/artikel`}>
										<span className={classes.nameBreadcrumb} style={{ cursor: 'pointer' }}>
											{r.breadcrumbName}
										</span>
									</a>
									:
									<a href={`${process.env.NEXT_PUBLIC_WEB_URL}/`}>
										<span className={classes.nameBreadcrumb} style={{ cursor: 'pointer' }}>
											{r.breadcrumbName}
										</span>
									</a>
							}
						</Breadcrumb.Item>
					);
				} else {
					return (
						<Breadcrumb.Item key={r.path}>
							<a href={`${process.env.NEXT_PUBLIC_WEB_URL}${r.path}`}>
								<span className={classes.nameBreadcrumb} style={{ cursor: 'pointer' }}>
									{r.breadcrumbName}
								</span>
							</a>
						</Breadcrumb.Item>
					);
				}
			} else if (formatedBc[0].path === '/artikel') {
				if (formatedBc.length === i + 1) {
					if (i === 1) {
						const bcName = xs ? truncateString(r.breadcrumbName) : r.breadcrumbName;
						const formattedBreadcrumbName = bcName
							.split('-')
							.map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
							.join(' ');
						return (
							<span key={r.path} className={classes.lastBreadcrumb}>
								{formattedBreadcrumbName}
							</span>
						);
					}

					const fullText = props.pageHeaderContent.breadcrumbs.length === 4
						? toCamelCase(props?.pageHeaderContent?.breadcrumbs[3]?.label)
						: props.pageHeaderContent.breadcrumbs.length === 5
							? toCamelCase(props?.pageHeaderContent?.breadcrumbs[4]?.label)
							: r.breadcrumbName;

					const displayText = xs
						? (fullText.length > 33 ? fullText.slice(0, 33) + '...' : fullText)
						: fullText;
					return <span key={r.path} style={{ fontSize: `${xs ? '12px' : '16px'}` }}>
						{displayText}
					</span>;
				}
				if (i === 0) {
					return (
						<Breadcrumb.Item key={0}>
							{
								r.breadcrumbName === 'Artikel' ?
									<a href={`${process.env.NEXT_PUBLIC_WEB_URL}/artikel`}>
										<span className={classes.nameBreadcrumb} style={{ cursor: 'pointer' }}>
											{r.breadcrumbName}
										</span>
									</a>
									:
									<a href={`${process.env.NEXT_PUBLIC_WEB_URL}/`}>
										<span className={classes.nameBreadcrumb} style={{ cursor: 'pointer' }}>
											{r.breadcrumbName}
										</span>
									</a>
							}
						</Breadcrumb.Item>
					);
				} else {
					return (
						<Breadcrumb.Item key={r.path}>
							<a href={`${process.env.NEXT_PUBLIC_WEB_URL}${r.path}`}>
								<span className={classes.nameBreadcrumb} style={{ cursor: 'pointer' }}>
									{r.breadcrumbName}
								</span>
							</a>
						</Breadcrumb.Item>
					);
				}
			} else {
				if (formatedBc.length === i + 1) {
					if (i === 2) {
						const bcName = xs ? truncateString(r.breadcrumbNoQuery) : r.breadcrumbNoQuery;
						const formattedBreadcrumbName = bcName
							.split('-')
							.map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
							.join(' ');
						return (
							<span key={r.path} className={classes.lastBreadcrumb}>
								{formattedBreadcrumbName}
							</span>
						);
					}
					return <span key={r.path}>{r.breadcrumbName}</span>;
				}
				if (i === 0) {
					return (
						<Breadcrumb.Item key={0}>
							<a href={`${process.env.NEXT_PUBLIC_WEB_URL}/artikel`}>
								<span className={classes.nameBreadcrumb} style={{ cursor: 'pointer' }}>
									{r.breadcrumbName}
								</span>
							</a>
						</Breadcrumb.Item>
					);
				} else {
					return (
						<Breadcrumb.Item key={r.path}>
							<a href={`${process.env.NEXT_PUBLIC_WEB_URL}${r.path}`}>
								<span className={classes.nameBreadcrumb} style={{ cursor: 'pointer' }}>
									{r.breadcrumbName}
								</span>
							</a>
						</Breadcrumb.Item>
					);
				}
			}
		});
	};

	return (
		<Layout className={classes.container}>
			<Layout
				className={classNames({
					'bg-white': isWhiteBackground,
					[classes['layout-body']]: !isWhiteBackground,
				})}
			>
				{router.pathname === '/kebijakan-privasi' ? (
					''
				) : router.pathname === '/faq' ? (
					''
				) : router.pathname === '/faq/[slug]' ? (
					''
				) : router.pathname === '/syarat-dan-ketentuan' ? (
					''
				) : router.pathname === '/cookies-consent' ? (
					''
				) : router.pathname === '/persetujuan-pelanggan' ? (
					''
				) : router.pathname === '/persetujuan-pelanggan-anak' ? (
					''
				) : scrollPosition !== 0 ? (
					<div>
						<Affix>
							<div
								style={{
									opacity: `${scrollPosition !== 0 ? 1 : 'transparent'}`,
									backgroundColor: `${scrollPosition == 0 ? 'transparent' : '#fff'}`,
									transition: 'opacity 6s ease-in-out ',
									zIndex: '1',
									height: '120px',
									boxShadow: '0 4px 10px rgba(235, 191, 191, 0.3)',
								}}
							>
								<HeaderNavigator />
							</div>
						</Affix>
					</div>
				) : (
					<HeaderNavigator />
				)}
				{router.pathname === '/artikel/[sub]' ? (
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24} style={{ marginTop: '16px' }}>
							<Layout className={classes.layoutBreadcrumb}>
								{PageHeader && (
									<div className={classes['page-body-wrap']}>
										<div className="container">
											<PageHeader
												breadcrumb={{ routes: getBreadcrumb(router) }}
												breadcrumbRender={itemRender}
											/>
										</div>
									</div>
								)}
							</Layout>
						</Col>
					</Row>
				) : router.pathname === '/kehamilan/[sub]' ? (
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24} style={{ marginTop: '16px' }}>
							<Layout className={classes.layoutBreadcrumb}>
								{PageHeader && (
									<div className={classes['page-body-wrap']}>
										<div className="container">
											<PageHeader
												breadcrumb={{ routes: getBreadcrumb(router) }}
												breadcrumbRender={itemRender}
											/>
										</div>
									</div>
								)}
							</Layout>
						</Col>
					</Row>
				) : router.pathname === '/pra-kehamilan/[sub]' ? (
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24}>
							<Layout className={classes.layoutBreadcrumb} style={{ marginTop: '16px' }}>
								{PageHeader && (
									<div className={classes['page-body-wrap']}>
										<div className="container">
											<PageHeader
												breadcrumb={{ routes: getBreadcrumb(router) }}
												breadcrumbRender={itemRender}
											/>
										</div>
									</div>
								)}
							</Layout>
						</Col>
					</Row>
				) : router.pathname === '/artikel/[phase]/[group]/[category]/[detail]' ? (
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24}>
							<Layout className={classes.layoutBreadcrumb} style={{ marginTop: '16px' }}>
								{PageHeader && (
									<div className={classes['page-body-wrap']}>
										<div className="container">
											<PageHeader
												breadcrumb={{ routes: getBreadcrumb(router) }}
												breadcrumbRender={itemRender}
											/>
										</div>
									</div>
								)}
							</Layout>
						</Col>
					</Row>
				) : router.pathname === '/pasca-kehamilan/[sub]' ? (
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24}>
							<Layout className={classes.layoutBreadcrumb} style={{ marginTop: '16px' }}>
								{PageHeader && (
									<div className={classes['page-body-wrap']}>
										<div className="container">
											<PageHeader
												breadcrumb={{ routes: getBreadcrumb(router) }}
												breadcrumbRender={itemRender}
											/>
										</div>
									</div>
								)}
							</Layout>
						</Col>
					</Row>
				) : router.pathname === '/resep/[sub]' ? (
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24} style={{ marginTop: '16px' }}>
							<Layout className={classes.layoutBreadcrumb}>
								{PageHeader && (
									<div className={classes['page-body-wrap']}>
										<div className="container">
											<PageHeader
												breadcrumb={{ routes: getBreadcrumb(router) }}
												breadcrumbRender={itemRender}
											/>
										</div>
									</div>
								)}
							</Layout>
						</Col>
					</Row>
				) : router.pathname === '/event/[sub]' ? (
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24} style={{ marginTop: '16px' }}>
							<Layout className={classes.layoutBreadcrumb}>
								{PageHeader && (
									<div className={classes['page-body-wrap']}>
										<div className="container">
											<PageHeader
												breadcrumb={{ routes: getBreadcrumb(router) }}
												breadcrumbRender={itemRender}
											/>
										</div>
									</div>
								)}
							</Layout>
						</Col>
					</Row>
				) : router.pathname === '/author/[sub]' ? (
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24} style={{ marginTop: '16px' }}>
							<Layout className={classes.layoutBreadcrumb}>
								{PageHeader && (
									<div className={classes['page-body-wrap']} style={{ backgroundColor: '#fff6f6' }}>
										<div className="container">
											<PageHeader
												breadcrumb={{ routes: getBreadcrumb(router) }}
												breadcrumbRender={itemRender}
											/>
										</div>
									</div>
								)}
							</Layout>
						</Col>
					</Row>
				) : (
					''
				)}

				<div className={isWhiteBackground ? bodyWhite : ''}>
					<Layout.Content>{props.children}</Layout.Content>
				</div>
				{router.pathname === '/kebijakan-privasi' ? (
					''
				) : router.pathname === '/faq' ? (
					''
				) : router.pathname === '/faq/[slug]' ? (
					''
				) : router.pathname === '/syarat-dan-ketentuan' ? (
					''
				) : router.pathname === '/cookies-consent' ? (
					''
				) : router.pathname === '/persetujuan-pelanggan' ? (
					''
				) : router.pathname === '/persetujuan-pelanggan-anak' ? (
					''
				) : (
					<Footers />
				)}
			</Layout>
		</Layout>
	);
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
MainLayout.getPageProps = (context: PageProps) => {
	return {
		pageHeader: true,
	};
};

export default MainLayout;
